import { render, staticRenderFns } from "./WorldInvoiceForm.vue?vue&type=template&id=d28fb27a&scoped=true&"
import script from "./WorldInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./WorldInvoiceForm.vue?vue&type=script&lang=js&"
import style0 from "./WorldInvoiceForm.vue?vue&type=style&index=0&id=d28fb27a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../food/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28fb27a",
  null
  
)

export default component.exports